import { DropBoxUserConfigModel } from "../../models/DropBoxUserConfigModel";

// get the configuration details of the exsting user
export const fetchUserDropBoxConfig = async (
  accessToken: string,
  userEmail: string,
  userID: number,
  tenantId: number
): Promise<DropBoxUserConfigModel | null> => {
  
  const queryParams = new URLSearchParams({
    userId: userID.toString(),
    tenantId: tenantId.toString(),
    userMail: userEmail || "",
  });
  const apiUrl = `${
    process.env.REACT_APP_API_URL
  }/api/DropBoxBusiness/GetUserDropBoxBusinessConfig?${queryParams.toString()}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: accessToken,
        "Content-Type": "application/json",
        Office365Mail: userEmail || "",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Dropbox config. Status: ${response.status}`
      );
    }
    const result = await response.json();
    const mappedConfig = mapToUserDropBoxConfig(result);
    console.log(
      "Extracted Dropbox user config: Mapped (dropBoxService):::",
      mappedConfig
    );

    return mappedConfig;
  } catch (error) {
    console.error("Error fetching Dropbox config:", error);
    return null;
  }
};
export const mapToUserDropBoxConfig = (data: any): DropBoxUserConfigModel => {
  return {
    dropBoxIntegrationId:  data.dropBoxIntegrationId,
    userId: data.userId,
    tenantId: data.tenantId,
    userEmail: data.userEmail,
    clinetID: data.clinetID,
    clinetSecret: data.clinetSecret,
    refreshToken: data.refreshToken,
    configType: data.configType,
    teamId: data.teamId,
    isBusiness: data.isBusiness,
  };
};

// create the user configuration
export const CreateUserDropBoxConfig = async (
  dropBoxUserConfig: DropBoxUserConfigModel,
  token: string,
  tenantId?: number
) => {
  try {
    
    // const endpoint = `${process.env.REACT_APP_API_URL}/api/DropBoxBusiness/CreateUserDropBoxBusinessConfig?tenantId=${tenantId}`;
    const endpoint = `${process.env.REACT_APP_API_URL}/api/DropBoxBusiness/CreateUserDropBoxBusinessConfig?tenantId=${tenantId}`;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dropBoxUserConfig),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    console.log("Created User Config Data (dropBoxService):::", responseData);
    return responseData;
  } catch (error) {
    console.error("Error in creating Dropbox config:", error);
    throw error;
  }
};

// get the accessToken from the RefreshToken
export const RefreshAccessToken = async (
  clientId: string,
  clientSecret: string,
  refreshToken: string
): Promise<string | null> => {
  try {
    const params = new URLSearchParams({
      refresh_token: refreshToken,
      grant_type: "refresh_token",
      client_id: clientId,
      client_secret: clientSecret,
    });

    const response = await fetch("https://api.dropboxapi.com/oauth2/token", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params.toString(),
    });

    const data = await response.json();

    if (data.access_token) {
      console.log(
        "Got New AccessToken From RefreshToken(dropBoxService):::",
        data.access_token
      );
      return data.access_token;
    } else {
      throw new Error("Token refresh from config failed");
    }
  } catch (error: any) {
    console.error("Refresh token error:", error.message);
    return null;
  }
};


// Add this function to your DropBox service file

export const CreateUserListDropBoxBusinessConfig = async (
  dropBoxUserList: any[],
  accessToken: string,
  tenantId: number
): Promise<{ success: boolean; message: string; data?: any }> => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/DropBoxBusiness/CreateUserListDropBoxBusinessConfig?tenantId=${tenantId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dropBoxUserList),
      }
    );

    const result = await response.json();

    if (response.ok && result.success) {
      return {
        success: true,
        message: result.message || "Team members saved successfully",
        data: result.data || result.newSubscription,
      };
    } else {
      return {
        success: false,
        message: result.message || result.Error || "Failed to save team members",
        data: result.data,
      };
    }
  } catch (error) {
    console.error("Error in CreateUserListDropBoxBusinessConfig:", error);
    return {
      success: false,
      message: `Network error: ${(error as Error).message}`,
      data: null,
    };
  }
};